export const LANGUAGES = [
  { name: 'English', code: 'en', flag: 'gb' },
  { name: 'French', code: 'fr-CA', flag: 'fr' },
  { name: 'German', code: 'de-DE', flag: 'de' },
  { name: 'Spanish', code: 'es-ES', flag: 'es' },
  { name: 'Norwegian', code: 'nn-NO', flag: 'no' },
  { name: 'Finnish', code: 'fi-FI', flag: 'fi' },
  { name: 'Danish', code: 'da-DK', flag: 'dk' },
  { name: 'Swedish - Sweden', code: 'sv-SE', flag: 'se' },
  { name: 'Swedish - Finland', code: 'sv-FI', flag: 'fi' },
  { name: 'Dutch - The Netherlands', code: 'nl-NL', flag: 'nl' },
  { name: 'Dutch - Belgium', code: 'nl-BE', flag: 'be' },
  { name: 'Polish', code: 'pl-PL', flag: 'pl' },
  { name: 'Czech', code: 'cs-CZ', flag: 'cz' },
  { name: 'Slovak', code: 'sl-SK', flag: 'sk' },
  { name: 'Hungarian', code: 'hu-HU', flag: 'hu' },
  { name: 'Arabic - Near East', code: 'ar', flag: 'ar' },
  { name: 'Serbian', code: 'sr-RS', flag: 'rs' },
  { name: 'English - United Kingdom', code: 'en-GB', flag: 'gb' },
  { name: 'English - United States', code: 'en-US', flag: 'us' },
  { name: 'Hebrew', code: 'he-IL', flag: 'il' },
]
